"use client";

import { Capacitor } from "@capacitor/core";
import { useEffect, useState } from "react";

export function PwaUpdateBanner() {
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);

  useEffect(() => {
    if (!("serviceWorker" in navigator) || Capacitor.isNativePlatform()) return;
    let disposed = false;
    let registration: ServiceWorkerRegistration | null = null;

    const watchInstalling = (worker: ServiceWorker | null) => {
      if (!worker) return;
      worker.addEventListener("statechange", () => {
        if (!disposed && worker.state === "installed" && navigator.serviceWorker.controller) setWaitingWorker(worker);
      });
    };

    void navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).then((nextRegistration) => {
      if (disposed) return;
      registration = nextRegistration;
      if (registration.waiting) setWaitingWorker(registration.waiting);
      watchInstalling(registration.installing);
      registration.addEventListener("updatefound", () => watchInstalling(registration?.installing ?? null));
    }).catch((caught) => console.warn("[P-010 PWA] Service Worker registration failed", caught));

    const checkForUpdate = () => { if (!document.hidden) void registration?.update(); };
    const timer = window.setInterval(checkForUpdate, 30 * 60 * 1000);
    document.addEventListener("visibilitychange", checkForUpdate);
    const reload = () => window.location.reload();
    navigator.serviceWorker.addEventListener("controllerchange", reload);
    return () => {
      disposed = true;
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", checkForUpdate);
      navigator.serviceWorker.removeEventListener("controllerchange", reload);
    };
  }, []);

  if (!waitingWorker) return null;
  return (
    <aside className="pwa-update-banner" role="status" aria-live="polite">
      <span><strong>新しいバージョンがあります</strong><small>保存済みProjectはそのまま最新版へ更新できます。</small></span>
      <button type="button" onClick={() => waitingWorker.postMessage({ type: "SKIP_WAITING" })}>更新</button>
    </aside>
  );
}
